/* The screen for an address no route claims. */

import { useNavigate } from '@tanstack/react-router';
import { Button, Card, FullBleed } from '@indovation/design-system';
import { useI18n } from '@indovation/i18n/react';

export default function NotFound() {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <FullBleed panelExempt="No screen is registered here, so there is no context for a copilot.">
      <Card title={t('error.notFound.title')} description={t('error.notFound.description')}>
        <Button variant="primary" onClick={() => void navigate({ to: '/' })}>
          {t('shell.nav.home')}
        </Button>
      </Card>
    </FullBleed>
  );
}
